// vendor
import InApp from "detect-inapp";

const inApp = new InApp(navigator.userAgent || navigator.vendor);

export const isDesktop = () => {
	return inApp.isDesktop;
};

export const isMobile = () => {
	return inApp.isMobile;
};

export const isInApp = () => {
	return inApp.isInApp;
};

export const getBrowser = () => {
	return inApp.browser;
};

export const isAndroid = () => {
	return getUA().indexOf("android") > -1;
};

export const isIOS = () => {
	const ua = getUA();
	const phone = ua.match(/iphone/i) !== null;
	const tablet = ua.match(/ipad/i) !== null;
	return phone || tablet;
};

// https://stackoverflow.com/questions/31569518/how-to-detect-facebook-in-app-browser
export const isFacebookApp = () => {
	const ua = getUA();
	return (ua.indexOf("fban") > -1) || (ua.indexOf("fbav") > -1) || (ua.indexOf('instagram') > -1);
};

const getUA = () => {
	return (navigator.userAgent || navigator.vendor).toLowerCase();
};